import * as React from 'react';
import { styled } from '@mui/material/styles';
import AppBar from '@mui/material/AppBar';
import Box from '@mui/material/Box';
import CssBaseline from '@mui/material/CssBaseline';
import Toolbar from '@mui/material/Toolbar';
import IconButton from '@mui/material/IconButton';
import HomeIcon from '@mui/icons-material/Home';
import ReceiptLongIcon from '@mui/icons-material/ReceiptLong';
import GroupIcon from '@mui/icons-material/Group';
import { useNavigate, useLocation } from 'react-router-dom';

export default function NavBar() {
    const navigate = useNavigate();
    const location = useLocation();
    const defaultPath = '/home';

    // Updated navigation handler with scroll behavior
    const handleNavigation = (path) => {
        // First scroll to top
        window.scrollTo({
            top: 0,
            left: 0,
            behavior: 'instant'
        });
        // Then navigate
        navigate(path);
        // Add a backup scroll after a slight delay to handle any dynamic content
        setTimeout(() => {
            window.scrollTo({
                top: 0,
                left: 0,
                behavior: 'instant'
            });
        }, 100);
    };

    const getButtonStyle = (path) => ({
        fontSize: '2rem',
        padding: '10px 20px',
        borderRadius: '20px',
        border: '2px solid white',
        backgroundColor: location.pathname === path || (location.pathname === '/' && path === defaultPath) ? 'var(--highlight-color)' : 'var(--backing-color)',
        color: 'var(--text-color)',
        '&:hover': {
            backgroundColor: 'var(--highlight-color)',
        },
    });

    return (
        <React.Fragment>
            <CssBaseline />
            <AppBar 
                position="fixed"
                sx={{ 
                    top: 'auto', 
                    bottom: 0, 
                    width: '100%',
                    backgroundColor: 'var(--background-color)', 
                    borderTop: '2px solid white', 
                    boxShadow: '0px -2px 10px rgba(0, 0, 0, 0.5)' 
                }}
            >
                <Toolbar sx={{ minHeight: 80 }}>
                    <Box
                        sx={{
                            width: '100%',
                            display: 'flex',
                            justifyContent: 'space-evenly',
                            alignItems: 'center',
                        }}
                    >
                        <IconButton
                            color="inherit"
                            onClick={() => handleNavigation(defaultPath)}
                            sx={getButtonStyle(defaultPath)}
                        >
                            <HomeIcon />
                        </IconButton>

                        <IconButton
                            color="inherit"
                            onClick={() => handleNavigation('/games')}
                            sx={getButtonStyle('/games')}
                        >
                            <ReceiptLongIcon />
                        </IconButton>

                        <IconButton
                            color="inherit"
                            onClick={() => handleNavigation('/players')}
                            sx={getButtonStyle('/players')}
                        >
                            <GroupIcon />
                        </IconButton>

                        <IconButton
                            color="inherit"
                            onClick={() => handleNavigation('/visualizations')}
                            sx={getButtonStyle('/visualizations')}
                        >
                            <GroupIcon />
                        </IconButton>
                    </Box>
                </Toolbar>
            </AppBar>
        </React.Fragment>
    );
}